import React from 'react';
import ReactTooltip from 'react-tooltip';

import { TableRow, WrapperFlex, TableHeader } from '@unimed-fesp/components';

import theme from '../../../styles/theme';

const TableDocumentosHeader = ({ header }) => {
  return (
    <TableRow noWordBreak>
      <TableHeader maxWidth={120} minWidth={177}>
        Beneficiário
      </TableHeader>
      {header.map((doc) => (
        <TableHeader maxWidth={120} minWidth={157}>
          <WrapperFlex minContent data-tip={doc.nome} data-for="head">
            {doc.tipoDocumento}
          </WrapperFlex>
        </TableHeader>
      ))}
      <ReactTooltip
        id="head"
        className="extraClass"
        delayHide={false}
        effect="solid"
        backgroundColor={theme.greenHover}
        textColor="#FFF"
        place="bottom"
      />
    </TableRow>
  );
};

export default TableDocumentosHeader;
